import "../../assets/scss/custom/_careJourneyRoadmap.scss";

const SKELETON_STEPS = 6;

interface CareJourneyRoadmapSkeletonProps {
  /** Matches the roadmap's band heading, which stays as real text. */
  heading?: string;
  /** Matches the roadmap's in-card title, which stays as real text. */
  title?: string;
}

// Stand-in for CareJourneyRoadmap while the journey loads. Built from the
// roadmap's own classes, so the card, connectors, spacing and the narrow-width
// segmented bar match the real thing.
export const CareJourneyRoadmapSkeleton = ({
  heading,
  title,
}: CareJourneyRoadmapSkeletonProps) => {
  const card = (
    <div
      className="care-journey care-journey--skeleton placeholder-wave"
      aria-busy="true"
      aria-label="Loading care journey"
    >
      <div className="care-journey__header">
        {title && <h3 className="care-journey__title">{title}</h3>}
        <span className="placeholder care-journey__skeleton-summary" />
      </div>
      <ol className="care-journey__track" aria-hidden="true">
        {Array.from({ length: SKELETON_STEPS }).map((_, index) => (
          <li className="care-journey__step" key={index}>
            <div className="care-journey__step-inner">
              <span className="care-journey__node-wrap">
                <span className="care-journey__node" />
              </span>
              <span className="care-journey__text">
                <span className="placeholder care-journey__skeleton-eyebrow" />
                <span className="placeholder care-journey__skeleton-label" />
              </span>
            </div>
          </li>
        ))}
      </ol>
      <div className="care-journey__segments" aria-hidden="true">
        {Array.from({ length: SKELETON_STEPS }).map((_, index) => (
          <span className="care-journey__segment" key={index} />
        ))}
      </div>
    </div>
  );

  return heading ? (
    <div>
      <h2 className="ps-band-title">{heading}</h2>
      {card}
    </div>
  ) : (
    card
  );
};
